import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";

export default function Dashboard() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState("");
  const [userId, setUserId] = useState(null);

  const [stats, setStats] = useState({
    machines: 0,
    designers: 0,
    workspace: 0,
  });

  /* ================= LOAD USER ================= */
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (loginUser?.id) {
      setUser(loginUser.name);
      setUserId(loginUser.id);

      // ✅ FIX: parse provider_options safely
      let options = loginUser.provider_options;

      if (typeof options === "string") {
        try {
          options = JSON.parse(options);
        } catch {
          options = options.split(",");
        }
      }

      setRoles(Array.isArray(options) ? options : []);

      fetchDashboard(loginUser.id);
    }
  }, []);

  /* ================= FETCH DASHBOARD ================= */
  const fetchDashboard = async (userId) => {
    if (!userId) return;

    try {
      const res = await fetch(`${API.USER_DASHBOARD}&user_id=${userId}`);
      const data = await res.json();

      setStats({
        machines: (data.machines_active || 0) + (data.machines_pending || 0),
        designers: (data.designers_active || 0) + (data.designers_pending || 0),
        workspace: (data.workspace_active || 0) + (data.workspace_pending || 0),
      });
    } catch (error) {
      console.log("Dashboard Error:", error);
    }
  };
  const canMachine = roles.includes("machines");
  const canDesigner = roles.includes("designers");
  const canWorkspace = roles.includes("workspaces");
  return (
    <div className="dashboard-container">
      {/* HEADER */}
      <div className="dashboard-header">
        <div>
          <h2>Welcome Back 👋</h2>
          <p className="username">{user}</p>
        </div>

        {/* BUTTON TO CUSTOMER PAGE */}
        <button className="customer-btn" onClick={() => navigate("/")}>
          Go to Customer Page
        </button>
      </div>

      {/* STATS CARDS */}
      <div className="dashboard-grid">
        {canMachine && (
          <div className="dash-card">
            <h4>Machines</h4>
            <h2>{stats.machines}</h2>
          </div>
        )}

        {canDesigner && (
          <div className="dash-card">
            <h4>Designers</h4>
            <h2>{stats.designers}</h2>
          </div>
        )}

        {canWorkspace && (
          <div className="dash-card">
            <h4>Workspaces</h4>
            <h2>{stats.workspace}</h2>
          </div>
        )}
      </div>
    </div>
  );
}
